<template>
  <div class="logInComponent">
    <div class="logInContainer">
      <div class="logInCard">
        <div class="logoContainer">
          <img alt="ACG logo" class="logo" src="@/assets/img/logoblack.svg" />
        </div>
        <validation-observer  v-slot="{ handleSubmit }" tag="div">
          <form @submit.prevent="handleSubmit(formSubmit)"  class="form form--login" >
            <div class="inputContainer">
                <h3>Account validation</h3>
                <p>Create a password, use your e-mail address and this password for log in</p>
              <div>
                <ValidationProvider rules="required" v-slot="{ errors }"> 
                  <div class="form-row">
                    <input class="emailInput" placeholder="Name" name="Name"  type="text" v-model="user.name" />
                    <div class="form__error">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
                <ValidationProvider rules="required" v-slot="{ errors }"> 
                  <div class="form-row">
                    <input class="emailInput" placeholder="E-mail" name="E-mail" disabled type="text" v-model="user.email" />
                    <div class="form__error">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
                <ValidationProvider :rules="{required: true, regex: /^(?=.*(?:\d|[^\dA-Za-z]))(?=.*[A-Z]).*$/, min:8}" vid="userPassword" v-slot="{ errors }">
                  <div class="form-row">
                    <input class="passInput" placeholder="Password" name="Password" type="password" v-model="user.password" />
                    <div class="form__error">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
                <ValidationProvider :rules="{required: true, confirmed:'userPassword'}"  v-slot="{ errors }">
                  <div class="form-row">
                    <input class="passInput" data-vv-as="password" placeholder="Password Again" name="Password Again" type="password" v-model="user.passconf" />
                    <div class="form__error">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
                
              </div>
              <div class="error--s form__error" v-if="error.length > 0">{{error}}</div>
              <button type="submit" class="btn btn-green logInButton">Activate</button>
            </div>
          </form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend  } from 'vee-validate';
import {regex, required, confirmed, min} from 'vee-validate/dist/rules';
import { setInteractionMode } from 'vee-validate';

setInteractionMode('eager');
extend('required', {
  ...required,
  message: "{_field_} is required."
});
extend('regex', {
  ...regex,
  message: "Your password must contain at least one uppercase letter, and one number or special character"
});
extend("confirmed", {
  ...confirmed,
  message: "Not the same password",
});
extend('min', {
  ...min,
  message: "The password should be at least 8 characters"
});

export default {  
  data(){
    return{
      user:{
        email: null,
        psw: null
      },
      error: []
    }
  },
  components:{
    ValidationProvider,
    ValidationObserver        
  },
  created(){
      var _this = this;
    this.get('usermanager/getuserbyemailtoken/'+this.$route.params.token,{},function(resp){
        _this.user = resp.data.user
        //console.log(_this.user);
    },function(){
        alert('Invalid token!')
    })
  },
  methods:{
    formSubmit(){
        let _this = this
        this.user.token = _this.$route.params.token;
        _this.post('/usermanager/activate',
         this.user,
          {},function () {
            _this.$router.push({path:'/'})
            
          },function(error){
            //error
            console.log('login error:', error.response)
            
            if (error.response.data.error == 'Not found!'){
              _this.error = 'Wrong user name or password'
            } else if (error.response.data.error.password == 'number_or_special_need') {
              _this.error = 'Your password must contain at least one uppercase letter, and one number or special character'
            } else {
              _this.error = 'Something went wrong'
            }
          }
        )
    }
  }
}
</script>